import axios from '@/axios.js'

export default {
  fetchConfig({ commit }) {
    commit('SET_LOADING_CONFIG', true)
    return axios.get('/shopify/config')
      .then(res => { commit('SET_CONFIG', res.data); return res.data })
      .finally(() => commit('SET_LOADING_CONFIG', false))
  },
  saveConfig({ commit }, payload) {
    return axios.post('/shopify/config', payload)
      .then(res => { commit('SET_CONFIG', res.data); return res.data })
  },
  testConnection({ commit }) {
    return axios.post('/shopify/test')
      .then(res => { commit('SET_LAST_TEST', res.data); return res.data })
  },
  fetchCategories({ commit }) {
    commit('SET_LOADING_CATEGORIES', true)
    return axios.get('/shopify/categories')
      .then(res => { commit('SET_CATEGORIES', res.data); return res.data })
      .finally(() => commit('SET_LOADING_CATEGORIES', false))
  },
  syncCategory({ commit, dispatch }, payload) {
    const id = typeof payload === 'object' && payload !== null ? payload.idcategory : payload
    const body = typeof payload === 'object' && payload !== null
      ? {
          stockSource: payload.stockSource,
          stockOverrides: payload.stockOverrides,
          ...(Array.isArray(payload.optionFields) ? { optionFields: payload.optionFields } : {}),
        }
      : {}
    commit('SET_CATEGORY_BUSY', { id, busy: true })
    return axios.post(`/shopify/sync-category/${id}`, body)
      .then(res => {
        commit('UPDATE_CATEGORY', {
          id,
          status: 'synced',
          synced_variants: res.data.variants_synced,
          shopify_product_id: res.data.shopify_product_id,
          last_synced_at: new Date().toISOString(),
        })
        return res.data
      })
      .finally(() => commit('SET_CATEGORY_BUSY', { id, busy: false }))
  },
  fetchSyncPreview(_, payload) {
    const id = typeof payload === 'object' && payload !== null ? payload.idcategory : payload
    const optionFields = typeof payload === 'object' && payload !== null && Array.isArray(payload.optionFields)
      ? payload.optionFields
      : null
    const params = optionFields && optionFields.length
      ? { option_fields: optionFields.join(',') }
      : {}
    return axios.get(`/shopify/sync-preview/${id}`, { params }).then(res => res.data)
  },
  unsyncCategory({ commit }, idcategory) {
    commit('SET_CATEGORY_BUSY', { id: idcategory, busy: true })
    return axios.post(`/shopify/unsync-category/${idcategory}`)
      .then(res => {
        commit('UPDATE_CATEGORY', {
          id: idcategory,
          status: 'not_synced',
          synced_variants: 0,
          shopify_product_id: null,
          last_synced_at: null,
        })
        return res.data
      })
      .finally(() => commit('SET_CATEGORY_BUSY', { id: idcategory, busy: false }))
  },
  refreshStock({ commit }) {
    return axios.post('/shopify/stock/refresh')
      .then(res => { commit('SET_LAST_STOCK_SYNC', res.data); return res.data })
  },
  createAdhocProduct(_, payload) {
    return axios.post('/shopify/adhoc-product', payload).then(res => res.data)
  },
  uploadAdhocImage(_, file) {
    const form = new FormData()
    form.append('image', file)
    return axios.post('/shopify/upload-image', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(res => res.data)
  },
  saveSyncDefaults({ commit }, { sync_top_n_default }) {
    return axios.patch('/shopify/config/sync-defaults', { sync_top_n_default })
      .then(res => { commit('SET_CONFIG', res.data); return res.data })
  },
  saveCategoryTopN({ commit }, { id, top_n }) {
    return axios.patch(`/shopify/category/${id}/top-n`, { top_n })
      .then(res => {
        commit('UPDATE_CATEGORY', {
          id,
          sync_top_n_override: res.data.sync_top_n_override,
          effective_top_n: res.data.effective_top_n,
          eligible_product_count: res.data.eligible_product_count,
        })
        return res.data
      })
  },
}
